module.exports = __webpack_public_path__ + "static/media/chrome-512.6a341ef5.png";